export default __webpack_public_path__ + "static/media/logo_otego.d29ee21b.png";